__turbopack_context__.v({
  "card": "morning-banner-module-scss-module__o2wika__card",
  "content": "morning-banner-module-scss-module__o2wika__content",
  "cost": "morning-banner-module-scss-module__o2wika__cost",
  "dot": "morning-banner-module-scss-module__o2wika__dot",
  "fill": "morning-banner-module-scss-module__o2wika__fill",
  "index": "morning-banner-module-scss-module__o2wika__index",
  "item": "morning-banner-module-scss-module__o2wika__item",
  "label": "morning-banner-module-scss-module__o2wika__label",
  "list": "morning-banner-module-scss-module__o2wika__list",
  "name": "morning-banner-module-scss-module__o2wika__name",
  "number": "morning-banner-module-scss-module__o2wika__number",
  "photo": "morning-banner-module-scss-module__o2wika__photo",
  "plus": "morning-banner-module-scss-module__o2wika__plus",
  "price": "morning-banner-module-scss-module__o2wika__price",
  "root": "morning-banner-module-scss-module__o2wika__root",
  "spot": "morning-banner-module-scss-module__o2wika__spot",
  "stage": "morning-banner-module-scss-module__o2wika__stage",
  "thumb": "morning-banner-module-scss-module__o2wika__thumb",
  "title": "morning-banner-module-scss-module__o2wika__title",
  "veil": "morning-banner-module-scss-module__o2wika__veil",
});
